import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import {
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Alert,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { postFireTransaction } from "../../../Actions/InvoiceActs";
import { GlobalStore } from "../../../StateStores";

const FireArmControlNo = ({modelCtrl}) => {
  const [type, setType] = useState("Individual");
  const [entries, setEntries] = useState([{ id: Date.now(), name: "", mobile: "" }]);
  const [groupCompanyName, setGroupCompanyName] = useState("");
  const [policeStation, setPoliceStation] = useState("");
  const [errors, setErrors] = useState({});
  const [rate, setRate] = useState(40000);
  const [loading, setLoading] = useState(false);

  const {InvoiceDispatch, InvoiceState:{
    postInvoice:{
        isLoggedIn,
        data,
        error,
    }
  }} = useContext(GlobalStore);

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setEntries([{ id: Date.now(), name: "", mobile: "" }]);
    setGroupCompanyName("");
    setErrors({});
  };

  const handleEntryChange = (id, field, value) => {
    setEntries((prev) =>
      prev.map((entry) => (entry.id === id ? { ...entry, [field]: value } : entry))
    );
    setErrors((prev) => ({ ...prev, [`entry-${id}-${field}`]: "" })); // Clear error on input change
  };


  const addEntry = () => {
    setEntries([...entries, { id: Date.now(), name: "", mobile: "" }]);
  };

  const removeEntry = (id) => {
    setEntries(entries.filter((entry) => entry.id !== id));
  };

  const totalAmount = entries.length * rate;

  const validateForm = () => {
    let newErrors = {};

    if (!policeStation) newErrors.policeStation = "Police Station is required.";
    if ((type === "Group" || type === "Company") && !groupCompanyName)
      newErrors.groupCompanyName = `${type} Name is required.`;

    entries.forEach((entry) => {
      if (!entry.name) newErrors[`entry-${entry.id}-name`] = "Full Name is required.";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true)

    const formData = {
        type,
        policeStation,
        groupCompanyName: type !== "Individual" ? groupCompanyName : null,
        details: entries,
        rate,
        totalAmount,
      };

    try {

        const response = await postFireTransaction(formData)(InvoiceDispatch);

        if(response.status){
            toast.success(response.message);
            setEntries([{ id: Date.now(), name: "", mobile: "" }]);
            setPoliceStation("");
            setGroupCompanyName("");
            //Close the modal
           modelCtrl && modelCtrl()
        }

        setLoading(false)

    } catch (error) {
        toast.error(error.message)
    }
  };

  return (
    <Container className="mt-4">
      <Form>

        <FormGroup>
          <Label for="type">Select Type</Label>
          <Input type="select" id="type" value={type} onChange={handleTypeChange}>
            <option>Individual</option>
            <option>Group</option>
            <option>Company</option>
          </Input>
        </FormGroup>

        {(type === "Group" || type === "Company") && (
          <FormGroup>
            <Label for="groupCompanyName">{type} Name</Label>
            <Input
              type="text"
              id="groupCompanyName"
              placeholder={`Enter ${type} Name`}
              value={groupCompanyName}
              onChange={(e) => setGroupCompanyName(e.target.value)}
              invalid={!!errors.groupCompanyName}
            />
             <FormFeedback>{errors.groupCompanyName}</FormFeedback>
          </FormGroup>
        )}

        <FormGroup>
          <Label for="policeStation">Police Station</Label>
          <Input
            type="text"
            id="policeStation"
            placeholder="Enter Police Station Name"
            value={policeStation}
            onChange={(e) => setPoliceStation(e.target.value)}
            invalid={!!errors.policeStation}
          />
          <FormFeedback>{errors.policeStation}</FormFeedback>
        </FormGroup>

        <Card className="shadow-sm">
          <CardHeader>Details</CardHeader>
          <CardBody>
            {entries.map((entry) => (
              <Row key={entry.id} className="mb-2">
                <Col md={5}>
                  <Input
                    type="text"
                    placeholder="Full Name"
                    value={entry.name}
                    onChange={(e) => handleEntryChange(entry.id, "name", e.target.value)}
                    invalid={!!errors[`entry-${entry.id}-name`]}
                  />
                  <FormFeedback>{errors[`entry-${entry.id}-name`]}</FormFeedback>
                </Col>
                <Col md={5}>
                  <Input
                    type="text"
                    placeholder="Mobile (Optional)"
                    value={entry.mobile}
                    onChange={(e) => handleEntryChange(entry.id, "mobile", e.target.value)}
                  />
                </Col>
                {type !== "Individual" && (
                  <Col md={2}>
                    <Button color="danger" onClick={() => removeEntry(entry.id)}>-</Button>
                  </Col>
                )}
              </Row>
            ))}

            {type !== "Individual" && (
              <Button color="primary" onClick={addEntry} className="mb-2">
                Add Entry
              </Button>
            )}
          </CardBody>
          <CardFooter className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
            <div>
              <Label className="fw-bold mb-1">Choose Rate</Label>
              <div className="d-flex gap-3">
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      value={40000}
                      checked={rate === 40000}
                      onChange={() => setRate(40000)}
                    />{" "}
                    40,000 TZS
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      value={20000}
                      checked={rate === 20000}
                      onChange={() => setRate(20000)}
                    />{" "}
                    20,000 TZS
                  </Label>
                </FormGroup>
              </div>
            </div>

            <h5 className="mb-0">Total Amount: {totalAmount.toLocaleString()} TZS</h5>

            <Button color="primary" disabled={loading} onClick={handleSubmit}>
              {loading && <Spinner size="sm"/>} Submit
            </Button>
          </CardFooter>
        </Card>
      </Form>
    </Container>
  );
};

export default FireArmControlNo;